module.exports = __webpack_public_path__ + "resources/img/img_hi_psm3_m_en.45af4bfacef04e9fffd65b8118e80efe.png";